import { SLICE_TAG } from '@/constants';

import { apiSlice } from '../api-slice';
import {
    PurchaseReturnDetailsResponseSchema,
    PurchaseReturnListResponseSchema,
    TPurchaseReturnDetailsResponse,
    TPurchaseReturnListResponse,
} from './purchase-return.schema';

export const purchaseReturnApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createPurchaseReturn: builder.mutation({
            query: (data) => ({
                url: 'purchase-returns',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [SLICE_TAG.PURCHASE_RETURN, SLICE_TAG.PURCHASES],
        }),

        getAllPurchaseReturns: builder.query<
            TPurchaseReturnListResponse,
            Record<string, string | number | boolean | undefined>
        >({
            query(arg: Record<string, string | number | boolean>) {
                return {
                    url: 'purchase-returns',
                    method: 'GET',
                    params: arg,
                };
            },
            providesTags: [SLICE_TAG.PURCHASE_RETURN],
            transformResponse: (response) =>
                PurchaseReturnListResponseSchema.parse(response),
        }),

        getPurchaseReturnById: builder.query<
            TPurchaseReturnDetailsResponse,
            string
        >({
            query: (id: string) => ({
                url: `purchase-returns/${id}`,
                method: 'GET',
            }),
            providesTags: (_result, _query, id) => [
                { type: SLICE_TAG.PURCHASE_RETURN, id },
            ],
            transformResponse: (response) =>
                PurchaseReturnDetailsResponseSchema.parse(response),
        }),
    }),
});

export const {
    useCreatePurchaseReturnMutation,
    useGetAllPurchaseReturnsQuery,
    useGetPurchaseReturnByIdQuery,
    useLazyGetAllPurchaseReturnsQuery,
    useLazyGetPurchaseReturnByIdQuery,
} = purchaseReturnApi;
